var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 7H5a5.06 5.06 0 0 0-5 5v24a5.06 5.06 0 0 0 5 5h38a5.06 5.06 0 0 0 5-5V12a5.06 5.06 0 0 0-5-5ZM5 9h38a3.05 3.05 0 0 1 3 3v5H2v-5a3.05 3.05 0 0 1 3-3Zm38 30H5a3.05 3.05 0 0 1-3-3V19h44v17a3.05 3.05 0 0 1-3 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 25h10v2H6z"
  })));
};
export default SvgCreditCard;